export const protocolStateIds = {
    undefined: 0,
    // Создан
    created: 1,
    // В процессе
    signed: 2,
    declined: 3
}